import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./Footer";

function MainLayout({ children, onBack }) {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route

  // List of pages where the Back button should NOT appear
  const hiddenBackButtonPages = ["/", "/another-page"]; 

  return (
    <div>
      <main>{children}</main>

      {/* Show the Back button only if the current path is NOT in the hidden list */}
      {onBack && !hiddenBackButtonPages.includes(location.pathname) && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={() => {
              onBack(); // Clear authentication & credentials
              navigate("/"); // Redirect to home
            }}
          >
            Back
          </button>
        </div>
      )}

      <Footer platformColor="green" />
    </div>
  );
}

export default MainLayout;
